import { HeroConfig } from '../types/hero';

export const DEFAULT_HEROES: HeroConfig[] = [
  {
    id: 'hero-1-original',
    badge: 'ASSESSORIA TÉCNICA ESPECIALIZADA',
    title: 'Proteja Seu Patrimônio com Assessoria Técnica Especializada em Seguros',
    subtitle: 'A IBX Brasil oferece assessoria técnica completa para empresas que buscam segurança, economia e proteção adequada em seus contratos de seguros.',
    buttons: [
      {
        text: 'Solicitar Análise Gratuita',
        link: '/contato',
        type: 'primary'
      },
      {
        text: 'Conhecer Nossos Serviços',
        link: '/servicos',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-shield-check-fill',
        value: 'R$ 50M+',
        label: 'Patrimônio Protegido'
      },
      {
        icon: 'ri-team-fill',
        value: '500+',
        label: 'Clientes Atendidos'
      },
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Economia Média'
      },
      {
        icon: 'ri-star-fill',
        value: '97%',
        label: 'Taxa de Satisfação'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20with%20glass%20facade%20and%20blue%20sky%20professional%20business%20architecture%20clean%20minimalist%20design%20bright%20daylight%20wide%20angle%20view%20representing%20security%20and%20protection%20high%20quality%20professional%20photography&width=1920&height=1080&seq=hero-bg-1&orientation=landscape',
    isActive: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-2-assessoria',
    badge: 'ASSESSORIA ESPECIALIZADA EM SEGUROS',
    title: 'Conte com a Assessoria da IBX Brasil para Renovar Seus Seguros com Segurança e Economia',
    subtitle: 'Contar com a assessoria da IBX Brasil em suas renovações de seguros não é apenas uma solução inteligente para reduzir o custo do seu seguro. É também uma forma de evitar falhas contratuais e garantir uma proteção muito mais segura e eficiente para o seu patrimônio. Com mais de 33 anos de atuação no mercado de seguros, a IBX Brasil profissionaliza todo o processo de análise de riscos, definição de coberturas e negociação com corretores e seguradoras. Isso garante que cada contrato seja estruturado com estratégia, segurança e economia.',
    buttons: [
      {
        text: 'Solicitar Análise Gratuita',
        link: '/contato',
        type: 'primary'
      },
      {
        text: 'Falar com Especialista',
        link: 'https://wa.me/5511999999999?text=Olá!%20Gostaria%20de%20falar%20com%20um%20especialista%20sobre%20renovação%20de%20seguros.',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-time-fill',
        value: '33+',
        label: 'Anos de Experiência'
      },
      {
        icon: 'ri-team-fill',
        value: '500+',
        label: 'Clientes Atendidos'
      },
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Economia Média'
      },
      {
        icon: 'ri-star-fill',
        value: '97%',
        label: 'Taxa de Satisfação'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=professional%20business%20handshake%20meeting%20modern%20office%20corporate%20environment%20trust%20partnership%20consulting%20advisory%20services%20bright%20natural%20lighting%20clean%20professional%20atmosphere%20high%20quality%20business%20photography&width=1920&height=1080&seq=hero-bg-2&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-3-metodo',
    badge: 'MÉTODO DE CONTRATAÇÃO ATIVA',
    title: 'Contrate Seu Seguro com Estratégia e Método',
    subtitle: 'O Método de Contratação Ativa foi desenvolvido para ajudar segurados a tomar decisões técnicas na contratação e renovação de seguros. Ao aplicar esse método, você evita erros comuns cometidos por quem negocia seguros sozinho e pode reduzir significativamente o custo do seguro sem comprometer a proteção do patrimônio.',
    buttons: [
      {
        text: 'Conhecer o Método',
        link: '/estrategia',
        type: 'primary'
      },
      {
        text: 'Baixar o Ebook',
        link: '/contato',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-file-list-3-fill',
        value: '4',
        label: 'Etapas Estratégicas'
      },
      {
        icon: 'ri-shield-check-fill',
        value: '100%',
        label: 'Proteção Adequada'
      },
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Economia Média'
      },
      {
        icon: 'ri-award-fill',
        value: '33+',
        label: 'Anos de Expertise'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=strategic%20planning%20business%20documents%20charts%20graphs%20modern%20workspace%20professional%20analysis%20methodology%20process%20clean%20organized%20desk%20bright%20lighting%20corporate%20environment%20high%20quality%20professional%20photography&width=1920&height=1080&seq=hero-bg-3&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-4-profissionalizacao',
    badge: 'PROFISSIONALIZAÇÃO DA CONTRATAÇÃO DE SEGUROS',
    title: 'Negociar Seguro Sozinho Pode Custar Muito Mais Caro',
    subtitle: 'Muitos segurados ainda negociam seguros diretamente com corretores ou seguradoras sem suporte técnico especializado. Estudos indicam que essa prática pode resultar em seguros até 56% mais caros, além de coberturas inadequadas ou falhas contratuais. A IBX Brasil profissionaliza esse processo analisando riscos, revisando cláusulas e negociando estrategicamente com seguradoras para garantir economia e proteção adequada.',
    buttons: [
      {
        text: 'Solicitar Análise da Minha Apólice',
        link: '/contato',
        type: 'primary'
      },
      {
        text: 'Falar com Especialista',
        link: 'https://wa.me/5511999999999?text=Olá!%20Gostaria%20de%20falar%20com%20um%20especialista%20sobre%20análise%20de%20apólice.',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-error-warning-fill',
        value: '56%',
        label: 'Custo Extra sem Assessoria'
      },
      {
        icon: 'ri-shield-check-fill',
        value: 'R$ 50M+',
        label: 'Patrimônio Protegido'
      },
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Economia Média'
      },
      {
        icon: 'ri-team-fill',
        value: '500+',
        label: 'Clientes Atendidos'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=business%20professional%20analyzing%20documents%20contracts%20insurance%20policy%20review%20modern%20office%20serious%20focused%20work%20professional%20consulting%20bright%20clean%20environment%20high%20quality%20corporate%20photography&width=1920&height=1080&seq=hero-bg-4&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-5-sinistros',
    badge: 'RECUPERAÇÃO DE SINISTROS',
    title: 'Seu Sinistro Foi Negado ou Subpago? A IBX Brasil Recupera o Que É Seu por Direito',
    subtitle: 'Muitas empresas aceitam indenizações abaixo do valor real por falta de suporte técnico especializado. A IBX Brasil atua na revisão e contestação de sinistros, garantindo que você receba a indenização correta, dentro do prazo e sem burocracia desnecessária. Não deixe dinheiro na mesa.',
    buttons: [
      {
        text: 'Analisar Meu Sinistro',
        link: '/servicos/recuperacao-sinistros',
        type: 'primary'
      },
      {
        text: 'Falar com Especialista',
        link: '/contato',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-money-dollar-circle-fill',
        value: 'R$ 12M+',
        label: 'Recuperado em Sinistros'
      },
      {
        icon: 'ri-shield-check-fill',
        value: '98%',
        label: 'Casos Resolvidos'
      },
      {
        icon: 'ri-time-fill',
        value: '30 dias',
        label: 'Prazo Médio de Resolução'
      },
      {
        icon: 'ri-team-fill',
        value: '500+',
        label: 'Clientes Atendidos'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=professional%20insurance%20claim%20recovery%20business%20meeting%20lawyer%20consultant%20reviewing%20documents%20modern%20office%20serious%20professional%20environment%20bright%20clean%20corporate%20setting%20high%20quality%20photography%20wide%20angle&width=1920&height=1080&seq=hero-bg-5&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-6-empresarial',
    badge: 'SEGURO EMPRESARIAL COMPLETO',
    title: 'Proteja Sua Empresa com um Seguro Estruturado por Especialistas',
    subtitle: 'Empresas que contratam seguros sem assessoria técnica correm o risco de pagar mais caro e ainda ficarem desprotegidas na hora do sinistro. A IBX Brasil estrutura coberturas personalizadas para o seu negócio, garantindo proteção real contra incêndio, responsabilidade civil, danos elétricos e muito mais.',
    buttons: [
      {
        text: 'Solicitar Diagnóstico Gratuito',
        link: '/contato',
        type: 'primary'
      },
      {
        text: 'Ver Coberturas Disponíveis',
        link: '/servicos/incendio-empresarial',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-building-2-fill',
        value: '300+',
        label: 'Empresas Protegidas'
      },
      {
        icon: 'ri-shield-check-fill',
        value: 'R$ 50M+',
        label: 'Patrimônio Segurado'
      },
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Economia Média'
      },
      {
        icon: 'ri-star-fill',
        value: '97%',
        label: 'Satisfação dos Clientes'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=modern%20industrial%20commercial%20building%20exterior%20professional%20corporate%20headquarters%20secure%20protected%20business%20environment%20clean%20architecture%20bright%20daylight%20wide%20angle%20high%20quality%20professional%20photography&width=1920&height=1080&seq=hero-bg-6&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-7-economia',
    badge: 'REDUZA O CUSTO DO SEU SEGURO',
    title: 'Pague Menos no Seguro Sem Abrir Mão da Proteção Que Você Precisa',
    subtitle: 'Com a assessoria técnica da IBX Brasil, empresas conseguem reduzir em média 35% no custo dos seus seguros, sem comprometer coberturas essenciais. Analisamos sua apólice atual, identificamos excessos e lacunas, e negociamos diretamente com as seguradoras para garantir o melhor custo-benefício do mercado.',
    buttons: [
      {
        text: 'Quero Reduzir Meu Seguro',
        link: '/contato',
        type: 'primary'
      },
      {
        text: 'Como Funciona',
        link: '/como-funciona',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Redução Média de Custo'
      },
      {
        icon: 'ri-money-dollar-circle-fill',
        value: 'R$ 8M+',
        label: 'Economizado para Clientes'
      },
      {
        icon: 'ri-team-fill',
        value: '500+',
        label: 'Empresas Beneficiadas'
      },
      {
        icon: 'ri-time-fill',
        value: '33+',
        label: 'Anos de Experiência'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=financial%20savings%20growth%20chart%20graph%20business%20success%20economy%20reduction%20cost%20professional%20office%20environment%20bright%20clean%20modern%20workspace%20corporate%20analytics%20high%20quality%20photography&width=1920&height=1080&seq=hero-bg-7&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-8-gestao',
    badge: 'GESTÃO ESTRATÉGICA DE CONTRATOS',
    title: 'Gerencie Todos os Seus Contratos de Seguro em Um Único Lugar',
    subtitle: 'Empresas com múltiplos contratos de seguro frequentemente perdem prazos de renovação, pagam duplicidades e mantêm coberturas desatualizadas. A IBX Brasil centraliza e gerencia todos os seus contratos, garantindo renovações estratégicas, coberturas adequadas e total controle sobre seu portfólio de seguros.',
    buttons: [
      {
        text: 'Centralizar Meus Contratos',
        link: '/servicos/gestao-contratos',
        type: 'primary'
      },
      {
        text: 'Falar com Consultor',
        link: '/contato',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-file-list-3-fill',
        value: '1.200+',
        label: 'Contratos Gerenciados'
      },
      {
        icon: 'ri-alarm-warning-fill',
        value: '0',
        label: 'Renovações Perdidas'
      },
      {
        icon: 'ri-shield-check-fill',
        value: '100%',
        label: 'Controle e Visibilidade'
      },
      {
        icon: 'ri-star-fill',
        value: '97%',
        label: 'Taxa de Satisfação'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=organized%20business%20contract%20management%20professional%20documents%20folders%20binders%20modern%20office%20desk%20clean%20organized%20workspace%20corporate%20environment%20bright%20natural%20lighting%20high%20quality%20professional%20photography&width=1920&height=1080&seq=hero-bg-8&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-9-vida',
    badge: 'SEGURO DE VIDA EMPRESARIAL',
    title: 'Proteja Seus Colaboradores e Garanta a Continuidade do Seu Negócio',
    subtitle: 'O seguro de vida empresarial é um dos benefícios mais valorizados pelos colaboradores e um instrumento estratégico para a continuidade dos negócios. A IBX Brasil estrutura planos personalizados que protegem sua equipe, reduzem o impacto de imprevistos e fortalecem a cultura de cuidado da sua empresa.',
    buttons: [
      {
        text: 'Estruturar Plano de Vida',
        link: '/servicos/vida-empresarial',
        type: 'primary'
      },
      {
        text: 'Solicitar Proposta',
        link: '/contato',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-heart-fill',
        value: '5.000+',
        label: 'Vidas Protegidas'
      },
      {
        icon: 'ri-building-2-fill',
        value: '300+',
        label: 'Empresas Clientes'
      },
      {
        icon: 'ri-percent-fill',
        value: '40%',
        label: 'Economia vs. Mercado'
      },
      {
        icon: 'ri-time-fill',
        value: '33+',
        label: 'Anos de Experiência'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=happy%20diverse%20corporate%20team%20employees%20smiling%20professional%20office%20environment%20teamwork%20collaboration%20business%20people%20modern%20workplace%20bright%20natural%20lighting%20high%20quality%20professional%20photography&width=1920&height=1080&seq=hero-bg-9&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'hero-10-diagnostico',
    badge: 'DIAGNÓSTICO GRATUITO DE RISCOS',
    title: 'Descubra Agora Se Sua Empresa Está Realmente Protegida',
    subtitle: 'A maioria das empresas acredita estar bem protegida, mas ao fazer um diagnóstico técnico, descobrimos lacunas críticas nas coberturas. A IBX Brasil oferece um diagnóstico gratuito e completo dos seus riscos empresariais, identificando vulnerabilidades e oportunidades de economia antes que um sinistro aconteça.',
    buttons: [
      {
        text: 'Fazer Diagnóstico Gratuito',
        link: '/contato',
        type: 'primary'
      },
      {
        text: 'Entender o Processo',
        link: '/como-funciona',
        type: 'secondary'
      }
    ],
    stats: [
      {
        icon: 'ri-search-eye-fill',
        value: '200+',
        label: 'Diagnósticos Realizados'
      },
      {
        icon: 'ri-error-warning-fill',
        value: '78%',
        label: 'Empresas com Lacunas'
      },
      {
        icon: 'ri-percent-fill',
        value: '35%',
        label: 'Economia Identificada'
      },
      {
        icon: 'ri-shield-check-fill',
        value: '100%',
        label: 'Gratuito e Sem Compromisso'
      }
    ],
    backgroundImage: 'https://readdy.ai/api/search-image?query=business%20risk%20analysis%20professional%20consultant%20reviewing%20audit%20checklist%20documents%20modern%20office%20magnifying%20glass%20inspection%20corporate%20environment%20bright%20clean%20professional%20high%20quality%20photography&width=1920&height=1080&seq=hero-bg-10&orientation=landscape',
    isActive: false,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];